import Cache from 'web-cache-facade';
import { getClientId } from '@/apis/report';
import { getUrlParam } from '@/utils/helper';
import { getUrl } from '@/utils/request';

const CACHE_KEY = 'ANSWERS_TIME_RECORD';
const TEN_MIN = 1000 * 60 * 10;
const sid = getUrlParam('sid');
let beginTime = 0;

function getInitValue() {
  return {
    pageStartTime: 0, // 翻页时间戳，当前的页面还未答题
    currentPageIndex: -1, // 当前的页码，从0开始
    lastAnsweredTime: 0, // 上一次回答的时间
    lastQuestionId: '', // 上一次回答的问题id
    answersTimeRecord: Cache.store('localStorage').get(CACHE_KEY) || {},
    submitted: false, // 是否是正常提交
  };
}

const values = getInitValue();
let {
  pageStartTime,
  currentPageIndex,
  lastAnsweredTime,
  lastQuestionId,
  answersTimeRecord,
  submitted,
} = values;

export function recordPageShow(pageIndex) {
  pageStartTime = Date.now();
  currentPageIndex = pageIndex;

  // 如果开始时间没值，则记录下
  if (beginTime === 0) {
    beginTime = pageStartTime;
  }

  if (!answersTimeRecord[pageIndex]) {
    answersTimeRecord[pageIndex] = {};
  }
}

export function recordAnswer(questionId) {
  if (currentPageIndex === -1) {
    return;
  }

  if (answersTimeRecord[currentPageIndex]?.[questionId]) {
    return;
  }

  const now = Date.now();

  if (pageStartTime > 0) {
    // pageStartTime大于0的时候，说明是刚进入当前页面，还未答题
    // 回答任意问题的时候减去进入页面时间，即可得到第一题的回答时间
    answersTimeRecord[currentPageIndex][questionId] = now - pageStartTime;
    pageStartTime = 0;
  } else {
    // 回答完第一道题，则继续回答其他问题，减去上一道题时间戳，即可得到后续问题的回答时间
    answersTimeRecord[currentPageIndex][questionId] = now - lastAnsweredTime;
  }

  lastAnsweredTime = now;
  lastQuestionId = questionId;

  // 因为答题数据会被缓存，所以答题时间记录也需要缓存
  Cache.store('localStorage').put(CACHE_KEY, answersTimeRecord, TEN_MIN);
}

async function report() {
  // 答题总数
  const record = Object.values(answersTimeRecord).reduce((acc, cur) => {
    // eslint-disable-next-line no-param-reassign
    acc = { ...acc, ...cur };
    return acc;
  }, []);
  const questionsCount = Object.keys(record).length;

  if (questionsCount < 1) {
    return;
  }

  // 答题总时长
  const answeredDurationStay = Date.now() - beginTime;
  const clientId = await getClientId();

  const data = {
    answersTimeRecord: record,
    submitted,
    questionsCount,
    answeredDurationStay,
    clientId,
  };
  if (lastQuestionId) {
    data.lastQuestionId = lastQuestionId;
  }
  const blob = new Blob([JSON.stringify(data)], { type: 'application/json; charset=UTF-8' });
  if (navigator?.sendBeacon) {
    navigator.sendBeacon(getUrl(`answers_behavior/${sid}`), blob);
  }
}

export async function recordSubmit() {
  submitted = true;
  await report();

  // reset data
  ({ pageStartTime, currentPageIndex, lastAnsweredTime } = values);
  answersTimeRecord = {};
  Cache.store('localStorage').forget(CACHE_KEY);
}

// 当页面关闭时候，记录退出时的题目id
window.addEventListener('unload', () => {
  if (submitted) {
    return;
  }

  report();
}, false);
